'use strict'
var twentyninetimes = twentyninetimes || {}

twentyninetimes.oembedToggle =
  twentyninetimes.oembedToggle ||
  (function () {
    function init() {
      var oembed_btns = document.querySelectorAll('.js-oembed-toggle')

      // Add intersection observer to see if video is in view
      const options = {
        root: document.querySelector('body'),
        rootMargin: '0px',
        threshold: 1.0,
      }

      // const observer = new IntersectionObserver(playVideoInView, options)

      // function playVideoInView(entries, observer) {}

      if (oembed_btns) {
        oembed_btns.forEach((btn) => {
          btn.addEventListener('click', function (e) {
            e.stopPropagation()

            var src = this.getAttribute('data-oembed-src'),
              new_src = src + '?rel=0&volume=1&quality=1080p&autoplay=1',
              parent = this.parentNode

            if (!parent.classList.contains('has-iframe')) {
              if (
                window.CookieInformation &&
                window.CookieInformation.getConsentGivenFor(
                  'cookie_cat_marketing'
                )
              ) {
                parent.classList.add('oembed-active')
                createIframe(new_src, parent)
              } else {
                if (!parent.querySelector('.video-consent-text')) {
                  var viewConsentText = document.createElement('div')
                  var button = this
                  viewConsentText.setAttribute('class', 'video-consent-text'),
                    (viewConsentText.innerHTML =
                      '<div><p>Cookies skal være accepteret for at kunne afspille denne video.</p><button class="btn video-consent-approve">Giv tilladelse og afspil</button></div>')
                  parent.appendChild(viewConsentText)
                  viewConsentText
                    .querySelector('.video-consent-approve')
                    .addEventListener('click', function (e) {
                      console.log('now giving consent')

                      viewConsentText.remove()
                      window.CookieInformation.submitAllCategories()
                      button.click()
                    })
                }
              }
            }
          })
        })
      }
    }

    function createIframe(src, parent) {
      var figure = document.createElement('figure'),
        iframe = document.createElement('iframe')

      figure.setAttribute('class', 'video-embed-wrapper')
      iframe.setAttribute('src', src)
      iframe.setAttribute('frameborder', '0')
      iframe.setAttribute('allow', 'autoplay; fullscreen')
      iframe.setAttribute('allowfullscreen', '')

      figure.appendChild(iframe)
      parent.appendChild(figure)

      setTimeout(function () {
        parent.classList.add('has-iframe')
      }, 600)
    }

    return {
      init: init,
    }
  })()
